
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "../../components/atoms/Container";
import { MedidaIcon, PesoIcon, UnitIcon } from "../../components/atoms/Icons";
import { Prose } from '../../components/atoms/Prose';
import { IIcon } from "../blog/BlogLayout";
import { PRODUCTS } from "./productsInfo";
import { Header } from "../../components/atoms/Header";

const previousPathname = "/";

function ArrowLeftIcon(props: IIcon) {

    return (
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" className={props.className}>
            <path
                d="M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export function ProductDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const index = Number(id);

    return (
        <>
            <Header />
            <Container className="mt-16 lg:mt-32">
                <div className="xl:relative">
                    <div className="mx-auto max-w-2xl">
                        {previousPathname && (
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                aria-label="Go back to articles"
                                className="group mb-8 flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 transition dark:border dark:border-zinc-700/50 dark:bg-zinc-800 dark:ring-0 dark:ring-white/10 dark:hover:border-zinc-700 dark:hover:ring-white/20 lg:absolute lg:-left-5 lg:mb-0 lg:-mt-2 xl:-top-1.5 xl:left-0 xl:mt-0"
                            >
                                <ArrowLeftIcon className="h-4 w-4 stroke-zinc-500 transition group-hover:stroke-zinc-700 dark:stroke-zinc-500 dark:group-hover:stroke-zinc-400" />
                            </button>
                        )}
                        <article>
                            <img className="mt-8 rounded-2xl h-full w-full sm:w-[672px] sm:h-[436px] rounded-4xl" src={PRODUCTS[index - 1].image} alt="" />
                            <div className="flex flex-col">

                                <div
                                    // dateTime={PRODUCTS[index - 1].date}
                                    className=" flex flex-col sm:flex-row items-start sm:items-center justify-between text-base text-zinc-400 dark:text-zinc-500"
                                >
                                    <div className="flex flex-col mt-5 justify-start text-gray-900 dark:text-white items-start">
                                        <div className="flex flex-row gap-2">
                                            <PesoIcon className="h-6 w-6 fill-black-900 dark:fill-white transition group-hover:fill-orange-800  dark:group-hover:fill-orange-800" />
                                            <span>{PRODUCTS[index - 1].peso} gramos</span>
                                        </div>
                                        <div className="flex justify-start gap-2">
                                            <MedidaIcon className="h-6 w-6 fill-black-900 dark:fill-white transition group-hover:fill-orange-800  dark:group-hover:fill-orange-800" />
                                            <span>{PRODUCTS[index - 1].medida} cm</span>
                                        </div>
                                        <div className="flex justify-start flex-row gap-2">
                                            <UnitIcon className="h-6 w-6 fill-black-900 dark:fill-white transition group-hover:fill-orange-800  dark:group-hover:fill-orange-800" />
                                            <span>{PRODUCTS[index - 1].unit} unidades</span>
                                        </div>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <div className="flex items-start gap-2">
                                            <h1 className="text-2xl font-bold tracking-tight text-zinc-800 dark:text-white">
                                                {PRODUCTS[index - 1].name}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Prose className="mt-8 text-gray-900 dark:text-white">{PRODUCTS[index - 1].description}</Prose>
                        </article>
                    </div>
                </div>
            </Container>
        </>
    );
}